<template>

	<div>
		<div class="col-xs-12 col-md-2">
			<p><b v-html="pagina.title.rendered"></b></p>
		</div>
		<div class="col-xs-12 col-md-10" v-html="pagina.content.rendered"></div>
	</div>

</template>


<script>
export default {
	props:[
		'pagina',
	],
	mounted: function() {
		// this.getPage();
	},
	data() {
		return {
			page: {},
			page_childrens: {},
			loaded: 'false',
			loaded_childrens: 'false',
			pageTitle: ''
		};
	},
	methods: {

	},
	watch: {
	}
};
</script>



// WEBPACK FOOTER //
// page_pioneros.vue?69255676